module.exports = __webpack_public_path__ + "static/img/turbo.c0cbdda.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/turbo.gif
// module id = YjpD
// module chunks = 2